export enum CourseDefaultViewType {
    Card = 0,
    List = 1,
    // Video = 2,
    // CardUnit = 3
}